import ColumnFilterContainer from '@/components/ColumnFilters/ColumnFilterContainer';
import type { ColumnFilterValue } from '@/models/flowFilter.type';
import { Input, SegmentedControl } from '@mantine/core';
import { useTranslate } from '@tolgee/react';

type BooleanColumnFilterProps = {
  label: string;
  value: ColumnFilterValue | undefined;
  onChange: (value: ColumnFilterValue | undefined) => void;
};

const ALL = 'all';

/** Filtre Tous / Oui / Non sur une colonne booléenne. */
const BooleanColumnFilter = ({ label, value, onChange }: BooleanColumnFilterProps) => {
  const { t } = useTranslate();
  const current = value?.kind === 'boolean' ? String(value.value) : ALL;

  return (
    <ColumnFilterContainer onReset={() => onChange(undefined)}>
      <Input.Wrapper label={label}>
        <SegmentedControl
          fullWidth
          mt={4}
          aria-label={label}
          value={current}
          onChange={next =>
            onChange(next === ALL ? undefined : { kind: 'boolean', value: next === 'true' })
          }
          data={[
            { value: ALL, label: t('common.filters.all') },
            { value: 'true', label: t('common.filters.yes') },
            { value: 'false', label: t('common.filters.no') },
          ]}
        />
      </Input.Wrapper>
    </ColumnFilterContainer>
  );
};

export default BooleanColumnFilter;
